import { useMemo } from 'react';

import { User } from '@/redux/apis/frontend-api';
import {
  GetV2QrCodesApiArg,
  useGetV2QrCodesQuery,
} from '@/redux/apis/codes-api';
import { useGetDebouncedCodeFilters } from '@/redux/features/code-filters/hooks';

const MULTI_COUNTRIES_FILTER: Record<string, string[]> = {
  'russian federation': ['russian federation', 'russia'],
  'czech republic': ['czech republic', 'czechia'],
  'south korea': ['korea', 'south korea'],
};

export const useGetQrCodesWithFilters = (
  user: User,
  options?: { debounce: number }
) => {
  const opts = useMemo(() => ({ debounce: 300, ...options }), [options]);
  const filters = useGetDebouncedCodeFilters(opts.debounce);
  const queryParams = useMemo(() => {
    const {
      onlyMyCodes,
      country,
      site,
      communicationPurpose,
      subcategory,
      component,
      department,
      carrierType,
      carrierSize,
      // date: { from, to },
    } = filters;

    const selectedCountries = country
      .map((name) => MULTI_COUNTRIES_FILTER[name] || name)
      .flat();

    const params: GetV2QrCodesApiArg = {
      username: onlyMyCodes ? user.username : undefined,
      locationCountry: selectedCountries.length ? selectedCountries : undefined,
      locationSite: site?.length ? site : undefined,
      communicationPurpose: communicationPurpose?.length
        ? communicationPurpose
        : undefined,
      subcategory: subcategory?.length ? subcategory : undefined,
      storeComponent: component?.length ? component : undefined,
      storeDepartment: department?.length ? department : undefined,
      carrierType: carrierType?.length ? carrierType : undefined,
      carrierSize: carrierSize?.length ? carrierSize : undefined,
    };

    // if (!params.country?.length) {
    //   delete params.country;
    // }

    // if (!params.cdsLocation?.length) {
    //   delete params.cdsLocation;
    // }

    // We leave these params in case we want to reuse them

    // if (from) {
    //   params.createdStart = new Date(from).toISOString();
    //   if (!to) {
    //     params.createdEnd = new Date(from).toISOString();
    //   } else {
    //     params.createdEnd = new Date(to).toISOString();
    //   }
    // }

    return params;
  }, [user, filters]);
  return useGetV2QrCodesQuery(queryParams);
};
